import './js/slider';

